import React from "react";

const NothingToShowHere = () => {
  return (
    <div className="nothing-to-show">
      <div className="nothing-box">Nothing to show</div>
    </div>
  );
};

export default NothingToShowHere;
